import { useEffect } from 'react';

import NameStep from '@pray/shared/components/onboarding/steps/Name/NameOnboardingStep';
import type { OnboardingStepProps } from '@pray/shared/components/onboarding/types';
import { useAuth } from '@pray/shared/hooks/useAuth';
import userService from '@pray/shared/services/userService';
import { getFirstAndLastName } from '@pray/shared/utils';
import { isValidName } from '@pray/shared/utils/validation';

import { additionalIdentifyUser } from 'utils/analytics/hubspot/tracking';

import { HUBSPOT_STEP_VIEW_EVENT_NAMES } from '../utils/constants';
import { hubspotTrackStepView } from '../utils/step-tracking';

export default function NameOnboardingStep({ form, onContinue, onBack, ...props }: OnboardingStepProps) {
  const { user } = useAuth();
  const isUserRegistered = user?.is_registered;

  useEffect(() => {
    hubspotTrackStepView(HUBSPOT_STEP_VIEW_EVENT_NAMES.NAME);
  }, []);

  // Validates current user name if it's registered, simulates Name step submission and move to next step
  useEffect(() => {
    if (isUserRegistered && user.name) {
      const isValidNameValue = isValidName(user.name);
      const { firstName, lastName } = getFirstAndLastName(user.name);
      if (isValidNameValue && firstName && lastName) {
        form.setValue('name', user.name);
        form.setValue('firstName', firstName);
        form.setValue('lastName', lastName);
        handleSuccess({ firstName, lastName });
        onContinue({ isSkipped: true });
      }
    }
  }, [isUserRegistered]);

  const handleSuccess = (data: { firstName: string; lastName: string }) => {
    if (isUserRegistered) userService.updateUser(user.id, { name: `${data.firstName} ${data.lastName}` });

    additionalIdentifyUser({
      firstName: data.firstName,
      lastName: data.lastName,
    });
  };

  return <NameStep form={form} onContinue={onContinue} onBack={onBack} onSuccess={handleSuccess} {...props} />;
}
